import { useEffect } from 'react';

export default function KeyboardShortcuts({ 
  onProtocolSearch, 
  onDocAssistant,
  enabled = true 
}) {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event) => {
      // Ctrl+K+P for Protocol Search
      if (event.ctrlKey && event.key === 'k') {
        event.preventDefault();
        // Wait for next key press
        const handleNextKey = (e) => {
          if (e.key === 'p') {
            e.preventDefault();
            onProtocolSearch && onProtocolSearch();
          } else if (e.key === 'd') {
            e.preventDefault();
            onDocAssistant && onDocAssistant();
          }
          window.removeEventListener('keydown', handleNextKey);
        };
        window.addEventListener('keydown', handleNextKey);
        
        // Timeout to remove listener if no follow-up key
        setTimeout(() => {
          window.removeEventListener('keydown', handleNextKey);
        }, 2000);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [enabled, onProtocolSearch, onDocAssistant]);

  return null; // This component doesn't render anything
}
